import Footer from "@components/layout/footer";
import Header from "@components/layout/header";
import LandingBottomCta from "./bottom-cta";
import LandingHeroSection from "./hero-section";
import PublishersCarousel from "./publisher-carousel";
import PublisherList from "./publisher-list";
import ReviewCarousel from "./review-carousel";
import LandingUsp from "./usp/[index]";
import { WhyUseLumiPageQuery } from "@graphql/generated/graphql";

interface WhyUseLumiPageProps {
  data: WhyUseLumiPageQuery;
  locale: string;
}

const WhyUseLumiPage: React.FunctionComponent<WhyUseLumiPageProps> = ({
  data,
  locale,
}) => {
  return (
    <>
      <Header showNewsStacks={false} />

      <main className="flex-1 overflow-hidden">
        <div className="relative mt-2 w-full">
          <LandingHeroSection locale={locale} bannerPhotoView={true} />
        </div>
        <PublishersCarousel data={data} />
        <div className="mx-auto max-w-7xl">
          <div className="mx-auto max-w-5xl">
            <LandingUsp />
          </div>
          <div className="px-6">
            <ReviewCarousel />
            <PublisherList data={data} />
          </div>
        </div>
        <LandingBottomCta />
        <Footer />
      </main>
    </>
  );
};

export default WhyUseLumiPage;
